import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';


import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';


import { DwellingApiService,
         ApplicationBidApiService }
from '../data-services/index';

import { IApplication,
         IApplicationBidInput,
         IContractor,
         ContractorApiService,
         AppLoadService}
from '@ebb-v2/ebb-integration';
import { cloneDeep } from '@apollo/client/utilities';

@Component({
    selector: 'ebb-portal-app-sheet-contractor',
    templateUrl: './app-sheet-contractor.component.html',
    standalone: false
})
export class AppSheetContractorComponent implements OnInit {
  public pageTitle = 'Contractor Directory';
  public genericLogo: string;
  public businessLogoRoot: string;
  public appZIP: string;
  public isPortal: boolean;
  public dwellingId: string;
  public dwellingLat: number;
  public dwellingLong: number;
  public openOption: 'default' | 'intro' | 'contractorChange' | 'estimate' | '2ndBid' = 'default';
  public disableSendRequest = true;
  public showCloseAfterRequest = false;
  public countSentEstimateRequests = 0;
  public programTypes: string;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private readonly refSheet: MatBottomSheetRef,
    private readonly fb: FormBuilder,
    private readonly apiAppSettings: AppLoadService,
    private readonly apiContractor: ContractorApiService,
    private readonly apiDwelling: DwellingApiService,
    private readonly apiApplicationBid: ApplicationBidApiService,
    private readonly cdRef: ChangeDetectorRef
  ) {
    const envSettings = this.apiAppSettings.readEnvironSettings();

    this.genericLogo = `${envSettings.uriEbbAssets}/images/ContractorLogo.png`;
    this.businessLogoRoot = `${envSettings.uriApiRoot}/files/contractorLogo/`;
  }

  ngOnInit() {
    const application = this.data.application as IApplication;
    if (!this.data.programTypes) {
      switch (application.programType) {
        case 700000003:
          this.data.programTypes = 'ESS';
          break;
        case 700000004:
          this.data.programTypes = 'EMR';
          break;
        default:
          this.data.programTypes = 'FEMA|EBB';
          break;
      }
    }
    
    this.appZIP = this.data.appZIP;
    this.dwellingId = this.data.dwellingId;
    this.openOption = this.data.openOption;
    this.isPortal = this.data.isPortal;
    this.programTypes = this.data.programTypes;
    this.loadData();
  }

  private loadData(): void {
    this.getDwellingLatLong();
  }

  public sendEstimateRequest(item: {contractor: IContractor, contactPreference: number }): void {
    const application = cloneDeep(this.data.application as IApplication);
    const applicationBidInput: IApplicationBidInput = {} as IApplicationBidInput;
    applicationBidInput.name = `${application._Ebb_OwnerId_Formatted} requested estimate from ${item.contractor.fullName}`;
    applicationBidInput._Ebb_ApplicationId = application.id;
    applicationBidInput._Ebb_OwnerId = application._Ebb_OwnerId;
    applicationBidInput._Ebb_ContractorId = item.contractor.id;
    applicationBidInput.homeownerContactPreference = item.contactPreference;
    this.apiApplicationBid
      .update(applicationBidInput)
      .subscribe(
        data =>cloneDeep(data),
        error => console.warn(error),
      );
  }

  public onSelectContractor(id: string): void {
    this.refSheet.dismiss(id);
  }

  public onClickClose(): void {
    this.refSheet.dismiss();
  }

  private getDwellingLatLong() {
    if ( this.dwellingId === '0' ) {
      this.dwellingLat = 38.580104;
      this.dwellingLong = -121.496007;
    }
    else if (this.areInvalid(this.dwellingLat, this.dwellingLong)) {
      this.apiDwelling
      .getDwelling(this.dwellingId)
      .subscribe(
        data => {
          this.dwellingLat = parseFloat(data.latitude);
          this.dwellingLong = parseFloat(data.longitude);
        },
        error => console.warn(error),
      );
    }
  }

  private areInvalid (lat: number, long: number): boolean {
    if (lat == null || lat === undefined || Number.isNaN(lat) || long == null || long === undefined || Number.isNaN(long)) {
      return true;
    }
    else {
      return false;
    }
  }
}
